import { render } from "./Attendanceedit.vue?vue&type=template&id=1f5b77c8&scoped=true&ts=true"
import script from "./Attendanceedit.vue?vue&type=script&lang=ts"
export * from "./Attendanceedit.vue?vue&type=script&lang=ts"

import "./Attendanceedit.vue?vue&type=style&index=0&id=1f5b77c8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5b77c8"]])

export default __exports__